import { api } from "@/api/axios.ts";
import { ApiJobLevel, ApiJobLevelBulkPayload } from "@/types/job-level.types.ts";

export const apiJobLevels = {
  getAll: async function (includeArchived: boolean = false) {
    return api.get<ApiJobLevel[]>("/api/v1/job-levels", { include_archived: includeArchived });
  },
  getById: async function (id: number) {
    return api.get<ApiJobLevel>(`/api/v1/job-levels/${id}`);
  },
  bulk: async function (payload: ApiJobLevelBulkPayload) {
    return api.put<ApiJobLevel[]>("/api/v1/job-levels/bulk", payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/job-levels/${id}`);
  },
};
